import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { Flex, Box } from '@rebass/grid'
import Badge from '../components/Badge'
import { ThemeConsumer } from 'styled-components'

const CompanyLogos = () => {
  const data = useStaticQuery(graphql`
    query {
      microsoft: file(relativePath: { eq: "logos/microsoft@2x.png" }) {
        childImageSharp {
          gatsbyImageData(width: 118, quality: 100, layout: FIXED)
        }
      }
      microsoftDark: file(relativePath: { eq: "logos/microsoft-dark@2x.png" }) {
        childImageSharp {
          gatsbyImageData(width: 118, quality: 100, layout: FIXED)
        }
      }
      intercom: file(relativePath: { eq: "logos/intercom@2x.png" }) {
        childImageSharp {
          gatsbyImageData(width: 131, quality: 100, layout: FIXED)
        }
      }
      intercomDark: file(relativePath: { eq: "logos/intercom-dark@2x.png" }) {
        childImageSharp {
          gatsbyImageData(width: 131, quality: 100, layout: FIXED)
        }
      }
      shopify: file(relativePath: { eq: "logos/shopify@2x.png" }) {
        childImageSharp {
          gatsbyImageData(width: 116, quality: 100, layout: FIXED)
        }
      }
      shopifyDark: file(relativePath: { eq: "logos/shopify-dark@2x.png" }) {
        childImageSharp {
          gatsbyImageData(width: 116, quality: 100, layout: FIXED)
        }
      }
      airbnb: file(relativePath: { eq: "logos/airbnb@2x.png" }) {
        childImageSharp {
          gatsbyImageData(width: 128, quality: 100, layout: FIXED)
        }
      }
      google: file(relativePath: { eq: "logos/google@2x.png" }) {
        childImageSharp {
          gatsbyImageData(width: 108, quality: 100, layout: FIXED)
        }
      }
      atlassian: file(relativePath: { eq: "logos/atlassian@2x.png" }) {
        childImageSharp {
          gatsbyImageData(width: 172, quality: 100, layout: FIXED)
        }
      }
      atlassianDark: file(relativePath: { eq: "logos/atlassian-dark@2x.png" }) {
        childImageSharp {
          gatsbyImageData(width: 172, quality: 100, layout: FIXED)
        }
      }
      salesforce: file(relativePath: { eq: "logos/salesforce@2x.png" }) {
        childImageSharp {
          gatsbyImageData(width: 62, quality: 100, layout: FIXED)
        }
      }
      discord: file(relativePath: { eq: "logos/discord@2x.png" }) {
        childImageSharp {
          gatsbyImageData(width: 131, quality: 100, layout: FIXED)
        }
      }
      bacardi: file(relativePath: { eq: "logos/bacardi@2x.png" }) {
        childImageSharp {
          gatsbyImageData(width: 97, quality: 100, layout: FIXED)
        }
      }
    }
  `)

  return (
    <ThemeConsumer>
      {(theme) => (
        <Flex
          flexWrap="wrap"
          alignItems="center"
          justifyContent="center"
          className="center">
          <Box width={1} mb={[2]}>
            <h6>IconJar is used by people from:</h6>
          </Box>
          <Box width={[1 / 2, 1 / 3, 1 / 4]} my={3}>
            <Box style={{ width: '118px', maxWidth: '100%' }} mx={'auto'}>
              <GatsbyImage
                image={getImage(
                  theme.appearance === 'light'
                    ? data.microsoft.childImageSharp
                    : data.microsoftDark.childImageSharp,
                )}
                alt="Microsoft logo"
              />
            </Box>
          </Box>
          <Box width={[1 / 2, 1 / 3, 1 / 4]} my={3}>
            <Box style={{ width: '131px', maxWidth: '100%' }} mx={'auto'}>
              <GatsbyImage
                image={getImage(
                  theme.appearance === 'light'
                    ? data.intercom.childImageSharp
                    : data.intercomDark.childImageSharp,
                )}
                alt="Intercom logo"
              />
            </Box>
          </Box>
          <Box width={[1 / 2, 1 / 3, 1 / 4]} my={3}>
            <Box style={{ width: '128px', maxWidth: '100%' }} mx={'auto'}>
              <GatsbyImage
                image={getImage(data.airbnb.childImageSharp)}
                alt="Airbnb logo"
              />
            </Box>
          </Box>
          <Box width={[1 / 2, 1 / 3, 1 / 4]} my={3}>
            <Box style={{ width: '108px', maxWidth: '100%' }} mx={'auto'}>
              <GatsbyImage
                image={getImage(data.google.childImageSharp)}
                alt="Google logo"
              />
            </Box>
          </Box>
          <Box width={[1 / 2, 1 / 3, 1 / 4]} my={3} display={['none', 'block']}>
            <Box style={{ width: '172px', maxWidth: '100%' }} mx={'auto'}>
              <GatsbyImage
                image={getImage(
                  theme.appearance === 'light'
                    ? data.atlassian.childImageSharp
                    : data.atlassianDark.childImageSharp,
                )}
                alt="Atlassian logo"
              />
            </Box>
          </Box>
          <Box width={[1 / 2, 1 / 3, 1 / 4]} my={3}>
            <Box style={{ width: '116px', maxWidth: '100%' }} mx={'auto'}>
              <GatsbyImage
                image={getImage(
                  theme.appearance === 'light'
                    ? data.shopify.childImageSharp
                    : data.shopifyDark.childImageSharp,
                )}
                alt="Shopify logo"
              />
            </Box>
          </Box>
          <Box width={[1 / 2, 1 / 3, 1 / 4]} my={3}>
            <Box style={{ width: '86px', maxWidth: '100%' }} mx={'auto'}>
              <GatsbyImage
                image={getImage(data.salesforce.childImageSharp)}
                alt="Salesforce logo"
              />
            </Box>
          </Box>
          <Box width={[1 / 2, 1 / 3, 1 / 4]} my={3}>
            <Box style={{ width: '131px', maxWidth: '100%' }} mx={'auto'}>
              <GatsbyImage
                image={getImage(data.discord.childImageSharp)}
                alt="Discord logo"
              />
            </Box>
          </Box>
        </Flex>
      )}
    </ThemeConsumer>
  )
}

export default CompanyLogos
